define(function (require, exports, module) {
    var EMPTY = '';
    var ARTICLE = 'Article';
    var BLOG = 'Blog';
    var RECAP = 'mlb_recap';

    var EMPTYOBJ = {};

    function tagParser (tag) {
        var extra = tag && tag.extraData;
        if (extra) {
            if (extra.value === RECAP) {
                this.isRecap = true;
            }
        }
    }

    function CmsDapiArticle (article, shouldParseMedia) {
        shouldParseMedia = shouldParseMedia !== false;
        this.id = this.slug = article.slug;
        this.linkId = article.slug;
        this.headline = article.headline || EMPTY;
        this.body = article.body || EMPTY;
        this.blurb = article.summary || EMPTY;

        this.parseData(article, shouldParseMedia);
    }

    CmsDapiArticle.prototype = {
        parseData: function (data, shouldParseMedia) {
            var fields = data.fields || EMPTYOBJ;
            var storyType = this.storyType = fields.storyType || ARTICLE;
            var tags = data.tags;

            this.isBlog = this.isCut4 = storyType === BLOG;
            this.isArticle = storyType === ARTICLE;
            this.isRecap = false;

            if (tags.length) {
                tags.forEach(tagParser, this);
            }
            if (shouldParseMedia) {
                // For the current usage, we don't need
                // photos... but maybe one day.
            }
        }
    };

    return CmsDapiArticle;
});
